import styles from "../../../styles/Components/pricing-plan/individual-services/SummaryBox.module.css";
import { Skeleton } from "antd";
import React from "react";

function SummaryBox({ icon, loading, title, value, children }) {
  return (
    <div className={styles.box}>
      <div className={styles.boxHeader}>
          <div className={styles.boxIcon}>{icon}</div>

          <div className={styles.boxContent}>
              <h6 className={styles.boxTitle}>{title}</h6>
              {loading ? (
                  <Skeleton.Node active />
              ) : (
                  <span className={styles.boxValue}>{value}</span>
              )}
          </div>
      </div>
      <div className={styles.boxBtns}>{children}</div>
    </div>
  );
}

export default SummaryBox;
